import { formatNumbers } from "../../lens-stats/formatters";

export const convertChartLabelNumber = (value: string): string => {
    const parsedValue = Number(value);
    return parsedValue < 1000 ? formatNumbers(parsedValue) : `${parsedValue / 1000}k`;
};
